import * as React from 'react';
export class TabFillerRenderer extends React.PureComponent {
    render() {
        return null;
    }
}
//# sourceMappingURL=tab-filler-renderer.js.map